import { z } from 'zod'

export const triggerItemSchema = z.object({
  name: z.string(),
  title: z.string(),
  description: z.string(),
})

export const triggerListSchema = z.array(triggerItemSchema)

export const applicationTriggerSchema = z.object({
  app_id: z.number(),
  title: z.string(),
  triggers: triggerListSchema,
})

export type ApplicationTrigger = z.infer<typeof applicationTriggerSchema>
